'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactJplayerUtils = require('react-jplayer-utils');
var _recompose = require('recompose');
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _playlistItem = require('./playlistItem');
var _playlistItem2 = _interopRequireDefault(_playlistItem);
var _constants = require('../../util/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var jPlaylists = _ref.jPlaylists;
  var id = _ref2.id,
    index = _ref2.index;
  return {
    className: (0, _classnames2.default)(_defineProperty({}, _constants.classes.CURRENT, jPlaylists[id].current === index))
  };
};
exports.default = (0, _recompose.compose)((0, _recompose.withContext)({
  index: _propTypes2.default.number
}, function (_ref3) {
  var index = _ref3.index;
  return {
    index: index
  };
}), (0, _reactJplayerUtils.connectWithId)(mapStateToProps))(_playlistItem2.default);